// The signing section's checks — the server's (app/modules/console/routers/
// signing.py): a stamp line is at most 300 characters and its only braces are
// the two placeholders, written as is.

import i18n from '@/i18n';

export const STAMP_LANGS = ['uz', 'ru', 'en'];
export const STAMP_TEXT_MAX = 300;

export function stampTemplateOk(text) {
  const rest = (text || '').replace(/\{(project|code)\}/g, '');
  return !rest.includes('{') && !rest.includes('}');
}

export function stampProblems(stampText) {
  const out = {};
  STAMP_LANGS.forEach((lang) => {
    const text = (stampText?.[lang] || '').trim();
    if (text.length > STAMP_TEXT_MAX) out[`stamp_text.${lang}`] = i18n.t('errors:fields.tooLong', { max: STAMP_TEXT_MAX });
    else if (!stampTemplateOk(text)) out[`stamp_text.${lang}`] = i18n.t('errors:invalid_stamp_template');
  });
  return out;
}
